var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Snav = function () {
	function Snav(target, rawopts) {
		var _this = this;

		_classCallCheck(this, Snav);

		// target
		this.target = target;

		// options
		var opts = this.opts = {};

		for (var opt in Snav.defaults) {
			opts[opt] = rawopts && opt in rawopts ? rawopts[opt] : Snav.defaults[opt];
		}

		// menu elements
		this.menu = {
			link: target.querySelector(opts.menuControlSelector),
			menu: target.querySelector(opts.submenuSelector),
			list: target.querySelector(opts.sublistSelector),
			parent: target.querySelector(opts.menuSelector),
			target: target
		};

		// initialize menu
		this.menu.isExpanded = this.menu.link.getAttribute('aria-expanded') === 'true';

		this.menu.menu.id = this.menu.menu.id || 'snav-' + ++Snav.uuid;

		this.menu.link.setAttribute('aria-controls', this.menu.menu.id);

		this.menu.link.setAttribute('aria-expanded', this.menu.isExpanded);

		if (this.menu.isExpanded) {
			target.setAttribute('data-expanded', '');
		} else {
			target.removeAttribute('data-expanded');
		}

		// initialize menus
		this.menus = [this.menu].concat(Array.prototype.slice.call(target.querySelectorAll(opts.menusSelector)).map(function (menu) {
			var link = menu.parentNode.querySelector(opts.sublinkSelector);

			var isExpanded = link.getAttribute('aria-expanded') === 'true';

			menu.id = menu.id || 'snav-' + ++Snav.uuid;

			link.setAttribute('aria-controls', menu.id);

			link.setAttribute('aria-expanded', isExpanded);
			menu.setAttribute('aria-hidden', !isExpanded);

			return {
				isExpanded: isExpanded,
				link: link,
				menu: menu
			};
		}));

		// initialize menu group
		this.more = target.querySelector(opts.moreSelector);

		this.isSmall = window.matchMedia('(max-width: 615px)');
		this.isSmallOrMedium = window.matchMedia('(max-width: 975px)');

		this.isSmall.addListener(function () {
			return _this.onmediachange();
		});

		this.onmediachange();

		this.menus.forEach(function (menu) {
			window.addEventListener('click', function (event) {
				if (menu.link.contains(event.target)) {
					event.preventDefault();

					_this.toggleMenu(menu);
				} else if (_this.isSmallOrMedium.matches && !_this.target.contains(event.target)) {
					_this.toggleMenu(menu, false);
				} else if (!_this.isSmallOrMedium.matches && !menu.menu.contains(event.target)) {
					_this.toggleMenu(menu, false);
				}
			});

			window.addEventListener('keydown', function (event) {
				if (event.keyCode === 27) {
					_this.toggleMenu(menu, false);
				}
			});
		});

		// manage target fixed state
		var gNav = document.getElementById("globalnav"),
			gnavH = null !== gNav ? gNav.offsetHeight : 56;
		this.targetScrollY = target.getBoundingClientRect().top + window.pageYOffset || gnavH;

		this.isFixed = false;

		window.addEventListener('scroll', function () {
			_this.onscroll();
		});

		this.onscroll();
	}

	_createClass(Snav, [{
		key: 'toggleMenu',
		value: function toggleMenu(menu, isExpanded) {
			var isExpanding = isExpanded === undefined ? !menu.isExpanded : isExpanded;

			if (isExpanding !== menu.isExpanded) {
				menu.isExpanded = isExpanding;

				menu.link.setAttribute('aria-expanded', isExpanding);
				menu.menu.setAttribute('aria-hidden', !isExpanding);

				if (menu.target) {
					if (isExpanding) {
						menu.target.setAttribute('data-expanded', '');
					} else {
						menu.target.removeAttribute('data-expanded');
					}
				}
			}
		}
	}, {
		key: 'onmediachange',
		value: function onmediachange() {
			this.menu.menu.setAttribute('aria-hidden', this.isSmallOrMedium.matches && !this.menu.isExpanded);

			if (this.isSmall.matches) {
				this.menu.menu.insertBefore(this.more, this.menu.list.nextSibling);

				this.menu.menu.setAttribute('role', 'navigation');
				this.menu.list.setAttribute('role', 'navigation');
			} else {
				this.target.appendChild(this.more);

				this.menu.menu.setAttribute('role', 'group');
				this.menu.list.removeAttribute('role');
			}
		}
	}, {
		key: 'onscroll',
		value: function onscroll() {
			var isFixing = window.pageYOffset >= this.targetScrollY;

			if (isFixing !== this.isFixed) {
				this.isFixed = isFixing;

				if (isFixing) {
					this.target.setAttribute('data-fixed', '');
				} else {
					this.target.removeAttribute('data-fixed');
				}
			}
		}
	}]);

	return Snav;
}();

/***************************************************/

Snav.uuid = 0;

Snav.defaults = {
	menuSelector: '.c-snav-menu',
	menuControlSelector: '.c-snav-menu-title',
	submenuSelector: '.c-snav-submenu',
	sublistSelector: '.c-snav-sublist',
	moreSelector: '.c-snav-more',
	menusSelector: '.c-snav-termenu',
	sublinkSelector: '.c-snav-sublink'
};

/***************************************************/
var $snav = document.querySelector('.c-snav');

if ($snav) {
	new Snav($snav); // eslint-disable-line no-new
}

/* v.0 */
//# sourceMappingURL=podcast.js.map
